import React from 'react';
import { LinkColumn } from './types';

export interface FooterColumnsProps {
  /** Array of link columns to render in the footer */
  columns: LinkColumn[];
  /** Accessible label for the nav landmark */
  ariaLabel?: string;
}

export const FooterColumns: React.FC<FooterColumnsProps> = ({ columns, ariaLabel }) => {
  if (columns.length === 0) return null;
  return (
    <nav aria-label={ariaLabel || 'Footer site map'} className="poly-page-footer__columns">
      {columns.map((col, index) => (
        <div key={index} className="poly-page-footer__column">
          <h3 className="poly-page-footer__column-title">{col.title}</h3>
          <ul>
            {col.links.map((link, i) => (
              <li key={i}><a href={link.url} data-cta-id={link.ctaId || undefined}>{link.text}</a></li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};
